import { ZONES, severityFill, worstSeverity } from "../lib/vehicle";
import type { Severity } from "../lib/inspection";

export interface DamageFinding { vehicleArea: string | null; severity: Severity }

/** Top-down car schematic. Zones with findings are tinted by their worst severity; interactive
 *  mode makes each zone tappable (to register a body damage). */
export function VehicleDiagram({ findings, onZoneClick, selected }: {
  findings: DamageFinding[];
  onZoneClick?: (code: string, label: string) => void;
  selected?: string | null;
}) {
  const byArea = new Map<string, Severity[]>();
  for (const f of findings) if (f.vehicleArea) byArea.set(f.vehicleArea, [...(byArea.get(f.vehicleArea) ?? []), f.severity]);

  return (
    <svg viewBox="0 0 200 388" className="mx-auto w-full max-w-[280px]" role="img" aria-label="Diagrama del vehículo">
      {/* body silhouette */}
      <rect x="30" y="8" width="140" height="372" rx="46" fill="#f5f7fa" stroke="#e6e7ea" />
      <rect x="60" y="106" width="80" height="34" rx="6" fill="#eef1f5" />
      <rect x="60" y="232" width="80" height="34" rx="6" fill="#eef1f5" />
      {ZONES.map((z) => {
        const sevs = byArea.get(z.code) ?? [];
        const worst = worstSeverity(sevs);
        const { fill, stroke } = severityFill(worst);
        const isSel = selected === z.code;
        const common = {
          fill,
          stroke: isSel ? "#0b0b0b" : stroke,
          strokeWidth: isSel ? 2 : 1,
          style: { cursor: onZoneClick ? "pointer" : "default" },
          onClick: onZoneClick ? () => onZoneClick(z.code, z.label) : undefined,
        };
        const marker = worst && (z.shape.type === "rect"
          ? { x: z.shape.x + z.shape.w / 2, y: z.shape.y + z.shape.h / 2 }
          : { x: z.shape.cx, y: z.shape.cy });
        return (
          <g key={z.code}>
            {z.shape.type === "rect"
              ? <rect x={z.shape.x} y={z.shape.y} width={z.shape.w} height={z.shape.h} rx="4" {...common} />
              : <circle cx={z.shape.cx} cy={z.shape.cy} r={z.shape.r} {...common} />}
            {marker && sevs.length > 0 && (
              <>
                <circle cx={marker.x} cy={marker.y} r="9" fill={severityFill(worst).stroke} />
                <text x={marker.x} y={marker.y + 3.2} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">{sevs.length}</text>
              </>
            )}
          </g>
        );
      })}
    </svg>
  );
}
